export default {
  noActions: {
    marginTop: 0,
  },
};
